import { render, staticRenderFns } from "./securities.vue?vue&type=template&id=665f847a&scoped=true"
import script from "./securities.vue?vue&type=script&lang=js"
export * from "./securities.vue?vue&type=script&lang=js"
import style0 from "./securities.vue?vue&type=style&index=0&id=665f847a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "665f847a",
  null
  
)

export default component.exports